/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RequestCompletionNotificationRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {RequestCompletionNotificationResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const requestCompletionNotification = (request:RequestCompletionNotificationRequest, options?: CashRequestOptions) => post<RequestCompletionNotificationRequest, RequestCompletionNotificationResponse>("/2.0/cash/request-completion-notification", request, {...options, rejectOnError: true })